import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';

@Component({
  selector: 'app-enviar-email',
  imports: [QuillModule, CommonModule, FormsModule],
  standalone: true,
  templateUrl: './enviar-email.component.html',
  styleUrls: ['./enviar-email.component.scss'],
})
export class EnviarEmailComponent implements OnInit {
    conteudoEmail: string = '';

  constructor() {}

  ngOnInit() {}

  fecharModal() {
    console.log('Modal fechado');
  }
}
